<template>

  <main v-if="page">
    <a v-if="page.entryType === 'popups'" @click.prevent="$router.go(-1)" class="c-btn-close"></a>

    <section v-if="page.pagetop">
      <div class="o-wrapper">

        <Pagetop :content="page.pagetop" />

      </div>
    </section>

    <section v-if="$route.name === 'JobsOverview'">
      <div class="o-wrapper">

        <div class="u-margin-top u-margin-top-huge@tablet u-margin-bottom-large">
          <Entry v-for="(item, index) in jobs" :key="index" :content="item" />
        </div>

      </div>
    </section>

    <section :class="page.entryType === 'popups' ? 'u-margin-top-huge' : ''">
      <div class="o-wrapper">

        <ContentBlocks :items="page.content" @slugUpdated="slugUpdated" />

      </div>
    </section>
  </main>

</template>

<script>
import { mapState } from 'vuex'
import anime from 'animejs'
import ContentBlocks from '@/components/ContentBlocks'
import Pagetop from '@/components/Pagetop'
import Entry from '@/components/Entry'

import objectFitImages from 'object-fit-images'

export default {
  name: 'Default',

  data () {
    return {
    }
  },

  beforeMount () {
    this.getPage(this.$route)

    if (this.$route.name === 'JobsOverview') {
      const lang = this.$route.params.lang
      this.$store.dispatch('getJobs', { lang: lang })
    }
  },

  mounted () {
    objectFitImages()
    this.$router.beforeEach((to, from, next) => {
      if (to.path !== from.path) {
          this.getPageWrapper(to, from, next)
        } else {
          next()
        }
    })

    // check hash after changing route (for within same page anchoring)
    this.$router.afterEach((to, from, next) => {
      this.checkHash()
    })

    this.checkHash()
  },

  methods: {
    checkHash () {
      if (this.$route.hash) {
        const hash = this.$route.hash.replace('#', '')
        const target = document.getElementById(hash)
        if (target) {
          // Set timeout to make sure the position of the element won't change mid scroll
          setTimeout(() => {
            this.$SmoothScroll(target, 400, false)
          }, 100)
        }
      }
    },

    slugUpdated () {
      // check hash after the slug in a content block changes
      this.$nextTick(function () {
        this.checkHash()
      })
    },

    getPageWrapper (to, from, next) {
      const _this = this
      // const target = document.querySelector('.c-bg-anim')
      anime({
        targets: '.c-bg-anim',
        duration: 800,
        translateX: window.innerWidth <= 768 ? '-95%' : '-20%',
        rotate: -20,
        easing: 'easeInQuad',
        complete: function (anim) {
          if (to.name !== 'Home') {
            _this.getPage(to)
          }
        }
      })

      if (to.name === 'JobsOverview') {
        const lang = this.$route.params.lang
        this.$store.dispatch('getJobs', { lang: lang })
      }

      setTimeout(() => {
        next()
      }, 800)
    },

    resetAnim () {
      anime({
        targets: '.c-bg-anim',
        duration: 800,
        translateX: '110%',
        rotate: -20,
        easing: 'easeInQuad'
      })
    },

    getPage (route) {
      const _this = this
      const single = route.meta.single
      const channel = route.meta.channel
      const lang = route.params.lang
      const slug = route.params.slug

      this.$store.commit('clearPage')

      if (single) {
        const handle = route.meta.handle
        this.$store.dispatch('getSingle', { slug: handle, lang: lang }).then(() => {
          _this.resetAnim()
        }).catch(() => {
          _this.$router.push(`/${lang}/404`)
        })
      } else if (channel) {
        const handle = route.meta.handle
        this.$store.dispatch('getChannel', { handle: handle, slug: slug, lang: lang }).then(() => {
          _this.resetAnim()
        }).catch(() => {
          _this.$router.push(`/${lang}/404`)
        })
      } else {
        this.$store.dispatch('getPage', { slug: slug, lang: lang }).then(() => {
          _this.resetAnim()
        }).catch(() => {
          _this.$router.push(`/${lang}/404`)
        })
      }
    }
  },

  computed: {
    seo () {
      return this.$store.state.seo[this.path]
    },

    ...mapState({
      path: state => state.seo.path,
      page: state => state.page,
      jobs: state => state.jobs
    })
  },

  components: {
    ContentBlocks,
    Pagetop,
    Entry
  },

  metaInfo () {
    return {
      title: this.seo.title,
      meta: [
        { property: 'og:title', content: this.seo.ogTitle },
        { property: 'twitter:title', content: this.seo.twitterTitle },
        { name: 'description', content: this.seo.description },
        { property: 'og:description', content: this.seo.ogDescription },
        { property: 'twitter:description', content: this.seo.twitterDescription },
        { property: 'og:image', content: this.seo.ogImage },
        { property: 'twitter:image', content: this.seo.twitterImage }
      ]
    }
  }
}
</script>
